export default __webpack_public_path__ + "static/media/none.d3e9b004.svg";